var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-content',[_c('div',{attrs:{"id":"core-view"}},[_c('v-fade-transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1)],1),(
      _vm.$route.name !== 'Login' &&
      _vm.$route.name !== 'EntityLink' &&
      _vm.$route.name !== 'EntityLinkHighlightedCard' &&
      _vm.$route.meta.isFrontend == true &&
      _vm.$route.name !== 'ProspectingBuyers' &&
      _vm.$route.name !== 'Home' &&
      _vm.$route.name !== 'About' &&
      _vm.$route.name !== 'GoodCausePublic'
    )?_c('core-about',{staticStyle:{"margin-top":"-5pt"}}):_vm._e(),(
      _vm.$route.name !== 'Login' &&
      _vm.$route.name !== 'EntityLink' &&
      _vm.$route.name !== 'EntityLinkHighlightedCard' &&
      _vm.$route.meta.isFrontend == true &&
      _vm.$route.name !== 'ProspectingBuyers'
    )?_c('core-footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }